import { ChangeEvent } from "react";
import { FormErrorsSchema } from "../../types";

export const Checkbox = ({
  label = undefined,
  name,
  key = undefined,
  checked = undefined,
  onChange,
  required = false,
  disabled = false,
  containerClassName = "w-full mt-6",
  errors,
}: {
  label?: string;
  name: string;
  key?: string;
  checked?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  disabled?: boolean;
  containerClassName?: string;
  errors?: FormErrorsSchema;
}) => {
  return (
    <div className={containerClassName} key={key}>
      <input
        type="checkbox"
        name={name}
        id={name}
        className="-mt-1 mb-0 mr-2 disabled:cursor-not-allowed"
        checked={checked}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
      {label && (
        <label htmlFor={name} className="text-gray-600">
          {label}
        </label>
      )}
      {errors &&
        errors[name] &&
        errors[name].map((error, index) => (
          <p key={index} className="mt-2 text-sm text-red-600">
            {error}
          </p>
        ))}
    </div>
  );
};
